/**
 * Optimizes an image URL by passing it through an Image CDN proxy.
 * This is primarily used to optimize Supabase Storage images to reduce egress,
 * converting them to WebP and resizing them.
 *
 * @param {string} url - The original image URL
 * @param {number} [width=400] - The desired width
 * @returns {string} The optimized image URL
 */
export const optimizeImageUrl = (url, width = 400) => {
  if (!url) return url;

  // Only proxy if it's a Supabase storage URL to avoid proxying already optimized images or other assets
  if (url.includes('supabase.co/storage/v1/object/public/')) {
    return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${width}&output=webp`;
  }

  return url;
};
